import React, {
  createContext,
  FC,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';

type PopFunction = (message: string) => void;

type Context = {
  pop: PopFunction;
};

const NotificationsContext = createContext<Context>({
  pop: () => {},
});

export const useNotification = () => useContext(NotificationsContext);

const origin: SnackbarOrigin = {
  horizontal: 'right',
  vertical: 'top',
};

const Notifications: FC = ({ children }) => {
  const [message, setMessage] = useState<string | null>(null);

  const pop = useCallback((message: string) => {
    setMessage(message);
  }, []);

  const handleClose = useCallback(() => {
    setMessage(null);
  }, []);

  const value = useMemo(() => ({ pop }), [pop]);

  return (
    <NotificationsContext.Provider value={value}>
      {children}
      <Snackbar
        anchorOrigin={origin}
        open={!!message}
        autoHideDuration={6000}
        onClose={handleClose}
        message={message}
      />
    </NotificationsContext.Provider>
  );
};

export default Notifications;
